import {Component, OnDestroy, OnInit} from '@angular/core';
import {CompanyService} from '../../services/company.service';
import {SupportChatService, THEME} from '../../services/support-chat.service';
import {take} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {getSickNoteIcon, IExtendedSickNote, listReasons} from '../../models/sick-note';
import {Messages} from '../../models/message';
import {ActivatedRoute} from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-informations',
  templateUrl: './informations.component.html',
  styleUrls: ['./informations.component.scss']
})
export class InformationsComponent implements OnInit, OnDestroy {
  title: string;
  body: string;
  messages: Messages;
  shortId: string;
  sickNote: IExtendedSickNote;
  reasons: string[];
  svgIcon: string;
  icon: string;

  constructor(private companyService: CompanyService,
              private supportChatService: SupportChatService,
              private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.supportChatService.setTheme(THEME.dark);
    this.route.queryParams
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        this.shortId = this.shortId || params.shortId;
        this.buildMessages();
      });
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: {resolved: IExtendedSickNote}) => {
        this.sickNote = data?.resolved;
        this.reasons = listReasons(this.sickNote);
        this.svgIcon = getSickNoteIcon(this.sickNote?.status)?.svgIcon;
        this.icon = getSickNoteIcon(this.sickNote?.status)?.icon;
        this.shortId = this.shortId || this.sickNote?.short_id;
      });
  }

  buildMessages(): void {
    this.companyService.messages$.pipe(take(1)).subscribe((messages) => {
      this.messages = messages;
      const messageStatus = messages.getMessageByStatus(this.sickNote?.status);
      this.title = messageStatus.title;
      this.body = messageStatus.body;
    });
  }

  ngOnDestroy(): void {
    this.supportChatService.setTheme(THEME.light);
  }
}
